enum SearchActionTypes {
    ClearCurrentResults = "SEARCH_CLEAR_RESULTS",

    ExecuteSearch = "SEARCH_EXECUTE",
    ExecuteSearchFulfilled = "SEARCH_EXECUTE_FULFILLED",
    ExecuteSearchPending = "SEARCH_EXECUTE_PENDING",
    ExecuteSearchRejected = "SEARCH_EXECUTE_REJECTED",

    SetSharepointResults = "ADD_SHAREPOINT_RESULTS",
    SetOnedriveResults = "ADD_ONEDRIVE_RESULTS",

    LoadCachedResult = "SEARCH_LOAD_CACHED_RESULT",
    ClearSearchCache = "SEARCH_CLEAR_CACHE",
    SetAiSummary = "SEARCH_SET_AI_SUMMARY",
    SetAiSearchFeedback = "SEARCH_SET_AI_SEARCH_FEEDBACK",
    SetAiSearchFeedbackMessageSentAction = "SEARCH_SET_AI_SEARCH_FEEDBACK_MESSAGE_SENT",
}

export default SearchActionTypes;
